"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMessageProviderTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _Permissions = require("../../constants/Permissions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsMessageProviderTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("AlertMessage").d("Alert Message"),
    column_name: "alert_message_pk",
    control: 'select',
    url: "/alert_message/all",
    properties: {
      column_name: "alert_message_pk",
      text_template: '{title}',
      label: "title",
      value: "pk",
      filter: {
        field: 'alert_message_pk',
        value: 'pk'
      }
    },
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("AlertProvider").d("Alert Provider"),
    column_name: "alert_provider_pk",
    filter: true,
    form_column_name: "alert_provider_pk",
    control: 'select',
    url: "/alert_provider/all",
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: _Permissions.Permissions.CAN_EDIT_ALERT_MESSAGE_PROVIDER,
    column_name: "actions",
    sortable: false,
    can_edit: false,
    can_create: false,
    element: row => {
      const name = row.name;
      return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Update", {
          name
        }).d("Update {name}"),
        url: "/alert_message_providers/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Delete", {
          name
        }).d("Delete {name}"),
        text: _reactIntlUniversal.default.get("DmsMessageProviderTable.DeleteButtonMessage", {
          name
        }).d("The {name} will be deleted. Are you sure about it?"),
        url: "/alert_message_providers/",
        row_pk: row.pk
      }));
    }
  }];
  const createAlert = async data => {
    const url = "/alert_message_providers";
    const response = await (0, _dmsbasereact.fetchData)(url, "POST", true, data);
    if (response.status === _dmsbasereact.HTTP_STATUS.CREATED_201) {
      table.current.updateTable();
      _sweetalert.default.fire({
        icon: "success",
        title: _reactIntlUniversal.default.get("MessageProviderCreated").d("Message Provider Created")
      });
    } else {
      var _response$data;
      _sweetalert.default.fire({
        icon: "error",
        title: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.detail
      });
    }
  };
  const toolbar = /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_ALERT_MESSAGE_PROVIDER
  }, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableCreateButton, {
    header: header,
    table: table,
    handler: createAlert,
    title: _reactIntlUniversal.default.get("CreateMessageProvider").d("Create Message Provider")
  }))));
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/alert_message_providers/table",
    export_table: false,
    toolbar: toolbar,
    responsive: true
  });
};
exports.DmsMessageProviderTable = DmsMessageProviderTable;